module.exports = __webpack_public_path__ + "static/img/honor7.a12e48e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor7.png
// module id = y6vp
// module chunks = 0